var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3257_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3447 19.0693L0.144531 36.6163C0.326458 37.2829 0.653386 37.8976 1.10032 38.4134C1.54726 38.9293 2.10238 39.3327 2.72324 39.5928C3.3441 39.8529 4.01426 39.9628 4.6825 39.9142C5.35074 39.8655 5.99936 39.6594 6.57879 39.3119L24.8071 28.5792L16.3447 19.0693Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.726 16.0866L24.8435 11.4189L15.9707 19.4684L24.8796 28.5539L32.7021 23.9363C33.3951 23.5611 33.9755 22.9971 34.3805 22.3052C34.7855 21.6133 34.9996 20.8201 34.9996 20.0114C34.9996 19.2027 34.7855 18.4094 34.3805 17.7176C33.9755 17.0257 33.3951 16.4616 32.7021 16.0865L32.726 16.0866Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.144964 3.31982C0.0471 3.69409 -0.001644 4.08026 4.22959e-05 4.46795V35.4682C0.00100863 35.8558 0.0497076 36.2417 0.144964 36.6165L16.9005 19.5188L0.144964 3.31982Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4655 19.9681L24.8433 11.4192L6.63922 0.636475C5.9543 0.221804 5.17531 0.00219444 4.38158 8.6686e-06C2.41187 -0.00394893 0.680195 1.34757 0.144531 3.30729L16.4655 19.9681Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3257_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/Play Store.ea35e4b8ef05e26b74804c8589c9115c.svg";
export { ForwardRef as ReactComponent };